import React, { useEffect, useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import ErrorPage from '@rsos/components/capstone/ErrorPage';
import { AppInnerWrapper } from '@rsos/components/capstone/Layout/AdminLayout/AdminLayout.styles';
import AppLoading from '@rsos/components/capstone/Layout/AppLoading';
import initialize from '../actions/initialize';
import Main from '../components/Main';
import { persistor } from '../store';

const useInitialize = dispatch => {
  useEffect(() => {
    (async () => {
      const action = await dispatch(initialize());
      if (action && action.error) {
        throw new Error(action.error);
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};

const App = () => {
  const dispatch = useDispatch();
  const { initializing, initialized, error } = useSelector(
    state => state.appIntegration,
  );
  useInitialize(dispatch);

  return useMemo(() => {
    if (error) {
      return <ErrorPage persistor={persistor} />;
    }
    if (initializing) {
      return <AppLoading />;
    }
    if (initialized) {
      return (
        <AppInnerWrapper>
          <Main />
        </AppInnerWrapper>
      );
    }
    return <ErrorPage persistor={persistor} />;
  }, [initializing, initialized, error]);
};
export default App;
